<p-table
  [value]="(dataSource | async) ?? []"
  [columns]="columns"
  [scrollable]="true"
  [paginator]="true"
  [rowsPerPageOptions]="[25, 50, 100, 200]"
  [showCurrentPageReport]="true"
  [rows]="10"
  [totalRecords]="metaData.totalRecords"
  [lazy]="true"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onLazyLoad)="loadDataLazy($event)"
>
  <ng-template pTemplate="header">
    <tr>
      <th *ngFor="let column of columns" [pSortableColumn]="column.field">
        {{ column.header }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td *ngFor="let column of columns">
        {{ row[column.field] }}
      </td>
    </tr>
  </ng-template>
</p-table>
